import { Button, Card, Stack, Typography } from "@mui/material";
import React from "react";
import UserLink, { IUserLink } from "./UserLink";
import { formatDateWithTime } from "../../../utils/date-formatter";
import { Link } from "react-router-dom";
import { useUrl } from "../../../hooks/urlEncoding";
import { routerPaths } from "../../../constants/Paths";
import { TicketListColumnFilterable } from "../../../services/Endpoints/tickets/TicketListEndpoints";
import { FilterOperatorEnum } from "../../../services/Schemas/ListQueryString";
import { BroadcastingListColumnFilterable } from "../../../services/Endpoints/broadcast";
import { PaymentAdListColumnFilterable } from "../../../services/Endpoints/payments/PaymentAdListEndpoint";
import { useCanAccess } from "../../../hooks/canAccess";
import { AccessEnums } from "../../../constants/accessEnum";

export default function UserOverviewCard({ user, disabled }: IUserLink) {
  const { queryStringUrl } = useUrl();
  const { can } = useCanAccess();

  const canAccess = can(AccessEnums.AdminUsersList) && user != undefined;
  return (
    <Card
      sx={{
        my: "20px",
        px: "20px",
        py: "12px",
        minWidth: "400px",
        width: "100%",
      }}
    >
      <Stack>
        <Typography>اطلاعات کاربر</Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="start"
          gap="10px"
        >
          <UserLink
            user={user}
            disabled={!can(AccessEnums.AdminUsersList) || user === undefined}
          />

          <Stack>
            <Typography textAlign="center" variant="footerRegular">
              تاریخ ایجاد
            </Typography>
            <Typography textAlign="center" variant="footerRegular" dir={"rtl"}>
              {user?.created_at &&
                formatDateWithTime({ lang: "fa", date: user?.created_at! })}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction="row"
          justifyContent="end"
          alignItems="center"
          gap="10px"
          mt="20px"
        >
          <Stack
            component={canAccess ? Link : Stack}
            to={queryStringUrl(routerPaths.SUPPORT, {
              filters: {
                [TicketListColumnFilterable.CREATOR_USER_ID]: {
                  column: TicketListColumnFilterable.CREATOR_USER_ID,
                  operator: FilterOperatorEnum.EQUAL,
                  value: user?.id ?? "",
                },
              },
            })}
            sx={{
              textDecoration: "none",
              height: "30px",
              color: canAccess ? "#fafafa" : "#444",
              bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              borderColor: "#3C9A4F",
              padding: "9px, 18px, 9px, 18px",
              fontWeight: "500",
              fontSize: "14.22px",
              px: "20px",
              borderRadius: "3px",
              justifyContent: "center",
              lineHeight: "27.02px",
              "&:hover": {
                color: canAccess ? "#fafafa" : "#444",
                bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              },
            }}
          >
            تیکت ها
          </Stack>
          <Stack
            component={canAccess ? Link : Stack}
            to={queryStringUrl(routerPaths.RECEIPTS, {
              filters: {
                [PaymentAdListColumnFilterable.USER_ID]: {
                  column: PaymentAdListColumnFilterable.USER_ID,
                  operator: FilterOperatorEnum.EQUAL,
                  value: user?.id ?? "",
                },
              },
            })}
            sx={{
              textDecoration: "none",
              height: "30px",
              color: canAccess ? "#fafafa" : "#444",
              bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              borderColor: "#3C9A4F",
              padding: "9px, 18px, 9px, 18px",
              fontWeight: "500",
              fontSize: "14.22px",
              px: "20px",
              borderRadius: "3px",
              justifyContent: "center",
              lineHeight: "27.02px",
              "&:hover": {
                // borderColor: "#3C9A4F",
                // backgroundColor: "#378c48",
                color: canAccess ? "#fafafa" : "#444",
                bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              },
            }}
          >
            پرداخت ها
          </Stack>
          <Stack
            component={canAccess ? Link : Stack}
            to={queryStringUrl(routerPaths.VOICE_BROADCASTS, {
              filters: {
                [BroadcastingListColumnFilterable.USER_ID]: {
                  column: BroadcastingListColumnFilterable.USER_ID,
                  operator: FilterOperatorEnum.EQUAL,
                  value: user?.id ?? "",
                },
              },
            })}
            sx={{
              textDecoration: "none",
              height: "30px",
              color: canAccess ? "#fafafa" : "#444",
              bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              borderColor: "#3C9A4F",
              padding: "9px, 18px, 9px, 18px",
              fontWeight: "500",
              fontSize: "14.22px",
              px: "20px",
              borderRadius: "3px",
              justifyContent: "center",
              lineHeight: "27.02px",
              "&:hover": {
                borderColor: "#3C9A4F",
                color: canAccess ? "#fafafa" : "#444",
                bgcolor: canAccess ? "#3C9A4F" : "#99999988",
              },
            }}
          >
            پیام های صوتی
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
